/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

// React
import { useState, useEffect } from "react";

// API Client
import apiClient from "apiClient";

export default function data() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchListings = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get("/admin/listings");
      // Response returns last 30 days of listings sorted by added date

      // Sort listings by added date in descending order (most recent first)
      const sortedListings = response.data.sort((a, b) => {
        const dateA = new Date(a.added?.at || a.added_at || a.createdAt || 0);
        const dateB = new Date(b.added?.at || b.added_at || b.createdAt || 0);
        return dateB - dateA;
      });

      setData(sortedListings);
    } catch (error) {
      console.error("Error fetching listings data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchListings();
  }, []);

  return {
    columns: [
      { Header: "Title", accessor: "name", width: "15%", align: "left" },
      { Header: "Category", accessor: "category", align: "center" },
      { Header: "Property Type", accessor: "property_type", align: "center" },
      { Header: "Price", accessor: "price", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Added Date", accessor: "added_date", align: "center" },
    ],
    rows: data.map((listing) => ({
      name: listing.name,
      category: listing.category,
      property_type: listing.property_type,
      price: listing.price || "0",
      status: listing.status === "Active" ? "Active" : "Inactive",
      added_date: new Date(listing.added?.at).toLocaleDateString(),
    })),
  };
}
